<template>
  <div class="card-section-wrapper">
    <div v-for="mod in cardList" :key="mod.id" class="card-section" :class="`card-section--${mod.displayModeCode}`">
      <component :is="resolveComponent(mod.displayModeCode)" :item="mod" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, markRaw, type Component } from 'vue'
import { useRoute } from 'vue-router'
import { Module, queryPageSection } from '@/api/page_config'
import { CARD_COMPONENT_MAP } from './card'

const cardList = ref<Module[]>([])
const route = useRoute()

function resolveComponent(modeCode: string): Component {
  const comp = CARD_COMPONENT_MAP[modeCode]
  return comp ? markRaw(comp) : markRaw(CARD_COMPONENT_MAP.Card)
}

// function handleCardClick(item: Module): void {
//   if (item.linkUrl && /^https?:\/\//i.test(item.linkUrl)) {
//     window.open(item.linkUrl, '_blank', 'noopener,noreferrer')
//   }
// }

async function loadModules(): Promise<void> {
  try {
    const res = await queryPageSection(route.path)
    cardList.value = (res.data.result.moduleList || []).sort((a, b) => a.sortNum - b.sortNum)
  } catch (e) {
    console.warn('[CardSection] queryPageSection failed:', e)
  }
}

onMounted(() => {
  loadModules()
})
</script>

<style scoped lang="scss">
@use '@/assets/styles/variables' as *;

.card-section-wrapper {
  width: 100%;
}

.card-section {
  width: 100%;
  padding: 1.5rem 1rem;
  background: $color-bg;

  @media (min-width: $breakpoint-md) {
    padding: 2rem;
  }

  @media (min-width: $breakpoint-lg) {
    padding: 2rem 0;
    max-width: $container-max-width;
    margin: 0 auto;
  }

  /* 全宽类型：清除左右内边距、宽度占满、白色背景 */
  &--SingleImg,
  &--BannerBg {
    padding-left: 0;
    padding-right: 0;
    max-width: 100%;
    background: transparent;

    @media (min-width: $breakpoint-lg) {
      padding-left: 0;
      padding-right: 0;
    }
  }

  /* TagBackground 允许轻微间距 */
  &--TagBackground {
    @media (min-width: $breakpoint-lg) {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }
}
</style>
